import "./NotificationRequest.styl";

import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import cn from "classnames";
import { register } from "../../../common/notification/actions";

import * as firebase from "firebase/app";
import "firebase/messaging";

import { Button } from "reactstrap";

class NotificationRequest extends React.Component {
  showPermissionRequest = () => {
    const { register } = this.props;

    if (typeof ga !== typeof undefined) {
      window.ga("send", "event", {
        eventCategory: "notification",
        eventAction: "success",
        eventLabel: "show-our-request"
      });
    }

    const messaging = firebase.messaging();
    const self = this;
    messaging
      .requestPermission()
      .then(function() {
        console.log("Notification permission granted.");
        messaging
          .getToken()
          .then(async function(currentToken) {
            if (
              currentToken &&
              !localStorage.getItem("push-notification-registered")
            ) {
              if (typeof ga !== typeof undefined) {
                window.ga("send", "event", {
                  eventCategory: "notification",
                  eventAction: "success",
                  eventLabel: "permission-granted"
                });
              }
              const rs = await register({ token: currentToken });
              if (rs && rs.status === 200) {
                localStorage.setItem("push-notification-registered", true);
                self.forceUpdate();
              }
            }
          })
          .catch(function(err) {
            console.log("An error occurred while retrieving token. ", err);
          });
      })
      .catch(function(err) {
        if (typeof ga !== typeof undefined) {
          window.ga("send", "event", {
            eventCategory: "notification",
            eventAction: "error",
            eventLabel: "permission-denied"
          });
        }
        console.log("Unable to get permission to notify.", err);
      });
  };

  hideRequest = () => {
    let t = new Date();

    t.setHours(t.getHours() + 24);
    localStorage.setItem("push-notification-hidden", t);
    this.forceUpdate();
  };

  shouldRender = () => {
    const isBrowser = typeof window !== "undefined";
    if (!isBrowser) {
      return false;
    }
    if (typeof Notification === "undefined") {
      return false;
    }
    if (!localStorage) {
      return false;
    }

    let isRegistered = true;
    let isHidden = false;

    if (isBrowser) {
      isRegistered = localStorage.getItem("push-notification-registered");

      const t = localStorage.getItem("push-notification-hidden");
      if (t) {
        const time = new Date(t);
        const now = new Date();
        isHidden = now.getTime() <= time.getTime();
      }
    }

    const isServiceWorkerAvailable =
      typeof navigator !== "undefined" && "serviceWorker" in navigator;

    if (isRegistered || !isServiceWorkerAvailable || isHidden) {
      return false;
    }

    return true;
  };

  render() {
    if (!this.shouldRender()) {
      return null;
    }
    return (
      <div className="notification-wrapper">
        <div className="notification-request fixed">
          Bądź na bieżąco! Wyślemy Ci powiadomienia o nowych ofertach pracy.
          <Button
            className="allow"
            color="secondary"
            onClick={this.showPermissionRequest}
          >
            Tak, chcę
          </Button>
          <i className="fa fa-close close-button" onClick={this.hideRequest} />
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    appPath: state.config.appPath
  }),
  { register }
)(NotificationRequest);



/** WEBPACK FOOTER **
 ** ./src/browser/components/NotificationRequest/NotificationRequest.js
 **/